// extracted by mini-css-extract-plugin
module.exports = {"icon":"_0af851d","withIcon":"_1a1b433"};